import { Link } from "react-router-dom";
import Input from "../../../components/input/input";
import Label from "../../../components/label/label";

function ObData({ onNext, onBack, formData, onUpdateData }) {
    const handleNextClick = () => {
        onNext(formData);
    };

    const handleBackClick = () => {
        onBack();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onUpdateData({ [name]: value });
    };

    return (
        <div>
            <h2>Fangen wir damit an, wo deine Firma gemeldet ist.</h2>
            <Label labelFor="address" labelValue="Adresse: " /><br/>
            <Input
                inputType="text"
                inputName="address"
                inputValue={formData.address || ''}
                onChange={handleInputChange}
                borderColor="black"
            /><br />
            <Label labelFor="postCode" labelValue="PLZ: " /><br/>
            <Input
                inputType="text"
                inputName="postCode"
                inputValue={formData.postCode || ''}
                onChange={handleInputChange}
                borderColor="black"
            /><br />
            <Label labelFor="town" labelValue="Stadt: " /><br/>
            <Input
                inputType="text"
                inputName="town"
                inputValue={formData.town || ''}
                onChange={handleInputChange}
                borderColor="black"
            />
            <div className="linkContainer">
                <Link onClick={handleBackClick}>Zurück</Link>
                <Link onClick={handleNextClick}>Weiter</Link>
            </div>
        </div>
    );
}

export default ObData;